import React from 'react'

import './backDrop.css'

const backDrop = props => {

    return (
        <div className='backdrop__div' onClick={props.click}  />
    )
  }
  
  export default backDrop;
